import camelcase from 'camelcase-keys-deep';
import { createReducer } from 'redux-act';
import { createResource } from '@gandi/resource/redux';
import { fetchPrices, selectPrices } from '../common';
const certTypeMap = {
  free: 'free',
  standard: 'std',
  pro: 'pro',
  business: 'bus'
};
export const getWarrantyOption = props => {
  if (props.type === 'free') {
    return '0';
  }
  switch (props.provider) {
    case 'digicert':
      if (props.type === 'standard') {
        return '10000';
      }
      if (props.type === 'pro' && props.protect === 'wildcard') {
        return '125000';
      }
      if (props.type === 'pro') {
        return '250000';
      }
      if (props.type === 'business') {
        return '1500000';
      }
      break;
    case 'sectigo':
    default:
      if (props.type === 'standard') {
        return '0';
      }
      if (props.type === 'pro' && props.protect === 'wildcard') {
        return '250000';
      }
      if (props.type === 'pro') {
        return props.warranty || '250000';
      }
      if (props.type === 'business') {
        return '250000';
      }
  }
  return props.warranty;
};
const certificateTypeMap = {
  free: 'free',
  std: 'standard',
  pro: 'pro',
  bus: 'business'
};
const certificateProtectOptionMap = {
  '1': 'single',
  w: 'wildcard'
};
const certificateProviderMap = {
  '': 'sectigo',
  sectigo: 'sectigo',
  digicert: 'digicert'
};
export const retrieveCertificateConfiguration = catalogName => {
  const catalogNameParts = catalogName.split('_');
  if (catalogNameParts.length < 5) {
    return undefined;
  }
  const type = certificateTypeMap[catalogNameParts[1]];
  const protect = catalogNameParts[2] in certificateProtectOptionMap ? certificateProtectOptionMap[catalogNameParts[2]] : 'multi';
  const numberAddresses = catalogNameParts[2];
  const warranty = String(parseInt(catalogNameParts[3], 10) * 1000);
  const provider = certificateProviderMap[catalogNameParts[5]] || 'sectigo';
  return {
    type,
    protect,
    numberAddresses,
    warranty,
    provider
  };
};
export const computeCertificateCatalogType = props => {
  const parts = ['cert'];
  if (props.type === 'pro' && props.protect === 'multi') {
    if (global.__DEV__) {
      console.log('multi protection is not available for pro cert');
    }
    return undefined;
  }
  if (props.type === 'business' && props.protect === 'wildcard') {
    if (global.__DEV__) {
      console.log('wildcard protection is not available for pro cert');
    }
    return undefined;
  }
  parts.push(certTypeMap[props.type]);
  if (certTypeMap[props.type] === 'free') {
    parts.push('1');
  } else if (props.protect === 'wildcard') {
    parts.push('w');
  } else if (!props.numberAddresses || props.protect === 'single') {
    const nbAddresses = props.protect === 'single' ? '1' : '3';
    parts.push(nbAddresses);
  } else if (props.type === 'pro') {
    if (global.__DEV__) {
      console.log('no multi addresses protection for pro cert');
    }
    parts.push('1');
  } else {
    parts.push(props.numberAddresses);
  }
  parts.push(parseInt(getWarrantyOption(props), 10) / 1000);
  parts.push('0');
  switch (props.provider) {
    case 'sectigo':
      break;
    default:
      parts.push(props.provider);
  }
  return parts.map(p => String(p)).join('_');
};
export const priceCertificatesResource = createResource('Price certificates');
export const fetchCertificatesPrices = fetchPrices(priceCertificatesResource);
export const selectCertificatesPrices = (state, props) => {
  const prices = selectPrices(state, {
    product: 'certificates',
    params: props
  });
  const products = prices?.products || [];
  return products.reduce((acc, product) => {
    acc[product.name] = product.prices[0] || {};
    return acc;
  }, {});
};
export const selectCertificatePrice = (state, props) => {
  const certificates = selectCertificatesPrices(state, props);
  const {
    process,
    productType,
    ...catalogTypeArgs
  } = props;
  const certificateCatalogName = computeCertificateCatalogType(catalogTypeArgs);
  if (!certificateCatalogName) {
    return undefined;
  }
  return certificates[certificateCatalogName];
};
const initialState = {};
const reducer = createReducer({
  [priceCertificatesResource.fetchOne.success.getType()]: (state, payload) => ({
    ...state,
    [payload.label]: camelcase(payload.response.data)
  })
}, initialState);
export default reducer;